import React, { forwardRef } from "react";

const SteppedNumberInput = forwardRef(function SteppedNumberInput(
  { className, wrapperClassName = "", onClick, ...inputProps },
  ref
) {
  const inputRef = React.useRef(null);

  React.useImperativeHandle(ref, () => inputRef.current);

  const dispatchInputEvents = () => {
    if (!inputRef.current) return;

    inputRef.current.dispatchEvent(new Event("input", { bubbles: true }));
    inputRef.current.dispatchEvent(new Event("change", { bubbles: true }));
  };

  const stepValue = (direction) => (event) => {
    event.preventDefault();
    event.stopPropagation();

    if (!inputRef.current) return;

    inputRef.current.focus();

    try {
      if (direction > 0) {
        inputRef.current.stepUp();
      } else {
        inputRef.current.stepDown();
      }
      dispatchInputEvents();
    } catch (error) {
      // Browser step APIs can throw if the current value is transient/invalid.
    }
  };

  return (
    <span className={`InventumNumberInputControl ${wrapperClassName}`.trim()}>
      <input
        {...inputProps}
        ref={inputRef}
        type="number"
        className={className}
        onClick={onClick}
      />
      <span className="InventumNumberInputStepper">
        <button
          type="button"
          className="InventumNumberInputStepButton InventumNumberInputStepButtonUp"
          aria-label="Increase value"
          tabIndex={-1}
          onPointerDown={stepValue(1)}
          onClick={(event) => event.stopPropagation()}
        />
        <button
          type="button"
          className="InventumNumberInputStepButton InventumNumberInputStepButtonDown"
          aria-label="Decrease value"
          tabIndex={-1}
          onPointerDown={stepValue(-1)}
          onClick={(event) => event.stopPropagation()}
        />
      </span>
    </span>
  );
});

export default SteppedNumberInput;
